import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Header from "../../front-end-global-components/components/Header/Header";
import {
  IncidentsCard,
  SelectedIncident
} from "../../front-end-global-components/components/Incidents/Incidents";
import { isValidObject } from "../../utils/validators";

export default function Incidents(props) {
  const navigate = useNavigate();
  const incidentId = window.location.pathname.split("/")?.[2] || null;
  return (
    <div className="inherit-parent-height">
      <Header
        title={incidentId ? "Incident management" : "All Incidents"}
        backButtonOnClick={() => {
          if (incidentId) {
            navigate("/incidents");
          } else {
            navigate("/");
          }
        }}
        hideSupport={true}
      />

      <div className="remaining-body-height padding-large overflow-scroll">
        <Routes>
          <Route
            index
            element={
              <IncidentsCard
                incidents={props.incidents}
                incidentOnClick={(incidentId) => {
                  navigate(`/incidents/${incidentId}`);
                }}
                userType="patients"
              />
            }
          />

          <Route
            path=":incidentId"
            element={
              <IncidentDetail incidentData={props.incidents?.[incidentId]} />
            }
          />
        </Routes>
      </div>
    </div>
  );
}

const IncidentDetail = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isValidObject(props.incidentData)) {
      navigate("/incidents");
    }
    // eslint-disable-next-line
  }, [props.incidentData]);

  if (!isValidObject(props.incidentData)) {
    return null;
  }

  return <SelectedIncident incident={props.incidentData} />;
};
